import React, { useEffect, useRef, useState } from "react";
import { AVATAR_PRESETS, resolveAvatarSrc } from "../../lib/avatars/index.js";
import { usePopoverPosition } from "./hooks/usePopoverPosition.js";

const AvatarPicker = ({
    value,
    onChange,
    allowPhoto = false,
    onRequestPhoto,
    color,
}) => {
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);
    const popoverRef = useRef(null);
    const fileInputRef = useRef(null);

    const popoverLeft = usePopoverPosition(open, containerRef, popoverRef);

    useEffect(() => {
        if (!open) return;

        const onPointerDown = (event) => {
            if (!containerRef.current?.contains(event.target)) setOpen(false);
        };
        document.addEventListener("mousedown", onPointerDown);
        return () => document.removeEventListener("mousedown", onPointerDown);
    }, [open]);

    const onFileChange = (event) => {
        const file = event.target.files?.[0];
        event.target.value = "";
        if (!file) return;

        setOpen(false);
        onRequestPhoto?.(file);
    };

    const onSelectPreset = (presetId) => {
        onChange(presetId);
        if (!allowPhoto) setOpen(false);
    };

    return (
        <div className="avatar-picker" ref={containerRef}>
            <button
                type="button"
                className="avatar-picker-current"
                style={{ "--user-color": color || "#855cd6" }}
                onClick={() => setOpen(!open)}
                title="Elegir avatar"
                aria-label="Elegir avatar"
            >
                <img src={resolveAvatarSrc(value)} alt="" />
            </button>

            {open && (
                <div
                    className="avatar-picker-popover"
                    ref={popoverRef}
                    style={{ left: `${popoverLeft}px` }}
                >
                    <div className="avatar-picker-grid">
                        {AVATAR_PRESETS.map((preset) => (
                            <button
                                key={preset.id}
                                type="button"
                                className={`avatar-picker-option${
                                    value === preset.id ? " selected" : ""
                                }`}
                                onClick={() => onSelectPreset(preset.id)}
                                title={preset.label}
                            >
                                <img src={preset.src} alt={preset.label} />
                            </button>
                        ))}
                    </div>

                    {allowPhoto && (
                        <>
                            <button
                                type="button"
                                className="avatar-picker-upload"
                                onClick={() => fileInputRef.current?.click()}
                            >
                                Subir una foto
                            </button>
                            <input
                                ref={fileInputRef}
                                type="file"
                                accept="image/png,image/jpeg,image/webp"
                                hidden
                                onChange={onFileChange}
                            />
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default AvatarPicker;
